import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error-client'
import {  useNavigate } from "react-router-dom";



const Invoice = ({ work_order, onWorkOrderChange, invoice_add_mode }) => {
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [isBtn, setIsBtn] = useState(false);
    const [addMode, setAddMode] = useState(false);
    const [invoice, setInvoice] = useState(null);
    const [client, setClient] = useState(null);

    const [invoiceAdd, setInvoiceAdd] = useState(null);
    const [inputError, setInputError] = useState(false);



  

    useEffect(() => {
       
        if (work_order?.work_order_id > 0 && work_order?.status >= 4) {
            getInvoice();
            getClientById(work_order?.client_id);

        }


    }, [work_order?.work_order_id, work_order?.status]);

    useEffect(() => {
        setAddMode(invoice_add_mode);
        setEditMode(false);
    }, [invoice_add_mode]);


    

    const getClientById = async () => {
    

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-client-by-id" , {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setClient(response?.data?.client);

            } else {

                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error,navigate)

        });

    
    }

    const getInvoice = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-invoice-by-work-order-id/"+ work_order?.work_order_id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setInvoice(response?.data?.invoice)



                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {

                catchError(error,navigate)


            });


    }



    return (
        <>


            {(work_order?.status >= 4) &&

                <>
                    <div className="row mt-2 mx-0 sub-heading">
                        <div className="col py-1">

                            <div className=" py-2 fw-bold text-dark">Invoice</div>

                        </div>
                        <div className="col py-1 text-end">


                                        
                                            {(invoice?.invoice_id > 0) &&
                                            <>
                                                <a href={"/client/invoice-print/"+work_order.work_order_id} className="btn btn-sm    btn-warning me-1 mt-1" type="button" target="_blank">Print Invoice</a>
                                         
                                            </>
}
                        </div>


                    </div>

                       
                                <>
                                    {(invoice?.invoice_id > 0) ?
                                        <>

                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Facility Fee: </label>
                                        <label className="field-info" >${parseFloat(invoice?.invoice_facility_fee).toFixed(2)}</label>
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Client Fee:</label>

                                        <label className="field-info" >${parseFloat(invoice?.invoice_client_fee).toFixed(2)}</label>


                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Miscellaneous Fee:</label>
                                        <label className="field-info" >${invoice?.invoice_misc_fee?parseFloat(invoice?.invoice_misc_fee).toFixed(2):""}</label>

                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">TOTAL FEE:</label>
                                        <label className="field-info" >${parseFloat(invoice?.invoice_facility_fee*1+invoice?.invoice_client_fee*1+invoice?.invoice_misc_fee*1).toFixed(2)}</label>


                                    </div>
                                </div>


                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-md-3 col-sm-3 ">
                                        <label htmlFor="invoice_notes">INVOICE NOTES:</label><br/>
                                        <label className="field-info tt-none" >{invoice?.invoice_notes?invoice?.invoice_notes:""}</label>



                                    </div>
                                   
                                    <div className="col-md-3 col-sm-3">
                                        <label htmlFor="invoice_recipient_email">MAIL TO:</label><br/>
                                        <label className="field-info  tt-none" >{invoice?.invoice_recipient_email?invoice?.invoice_recipient_email:""}</label>

                                       
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <label htmlFor="is_dollar_40">T/F:</label><br/>

                                        <label className="field-info" >{invoice?.is_dollar_40?invoice?.is_dollar_40:""}</label>

                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">PAYMENT:</label><br/>
                                        <label className="field-info" >{invoice?.is_credit_card == 1?"CREDIT CARD":"CHECK"}</label>

                                    </div>
                                   
                                </div>


    

                                    </>
                                        :
                                        <div className="row " >

                                            <div className="col-xl-12 col-lg-12 py-4 px-3" >

                                                <h5>No invoice has been generated yet.</h5>

                                            </div>

                                        </div>
                                    }
                                </>
                          
                </>
            }
        </>
    )

}
export default Invoice;